const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

// App locale is fixed to nl-BE throughout (see main.tsx adapterLocale).
const APP_LOCALE = 'nl-BE';

function formatDate(date: string): string {
  const [year, month, day] = date.split('-').map(Number);
  const d = new Date(year, month - 1, day);
  return new Intl.DateTimeFormat(APP_LOCALE, DATE_FORMAT_OPTIONS).format(d);
}

/**
 * Returns "DD/MM/YYYY HH:mm" (nl-BE date format, raw HH:mm time).
 * When time is absent, returns just the formatted date.
 */
export function formatDateWithTime(date: string, time?: string | null): string {
  if (!date) return '';
  const datePart = formatDate(date);
  return time ? `${datePart} ${time}` : datePart;
}

/**
 * Returns "start → end" in nl-BE date format with optional times.
 * Example: "08/07/2026 09:00 → 13/07/2026 17:00"
 */
export function formatDateRange(
  startDate: string,
  startTime: string | null | undefined,
  endDate: string,
  endTime: string | null | undefined,
): string {
  return `${formatDateWithTime(startDate, startTime)} → ${formatDateWithTime(endDate, endTime)}`;
}
